import React, { Component } from 'react'

// ui
import { Table, Tag } from 'antd'
import Button from '../../components/uielements/button'

// redux
import { connect } from 'react-redux'
import userActions from '../../redux/user/actions'

// const
import { default_avatar } from '../../redux/user/reducer'

// render column
const renderStatusColumn = text => {
    let display = ''
    let color = 'blue'

    switch (text) {
        case 1:
            display = 'Đang hoạt động'
            color = 'green'
            break

        case 2:
            display = 'Đã bị cấm'
            color = 'orange'
            break

        case 3:
            display = 'Đã bị xoá'
            color = 'red'
            break

        default:
            display = ''
    }

    return (
        <Tag key="text" color={color}>
            {display}
        </Tag>
    )
}

const renderAvatar = avatar => {
    if (avatar === '') avatar = default_avatar
    return (
        <img
            src={avatar}
            style={{ height: 43, width: 43, borderRadius: 22 }}
            alt="img"
        />
    )
}

// render table
const columns = [
    {
        align: 'center',
        title: 'Ảnh đại diện',
        dataIndex: 'avatar',
        key: 'avatar',
        render: renderAvatar,
    },
    {
        align: 'center',
        title: 'Tên hiển thị',
        dataIndex: 'display_name',
        key: 'display_name',
    },
    {
        align: 'center',
        title: 'Tên đăng nhập',
        dataIndex: 'user_name',
        key: 'user_name',
    },
    {
        align: 'center',
        title: 'Trạng thái tài khoản',
        dataIndex: 'status',
        key: 'status',
        render: renderStatusColumn,
    },
    {
        align: 'center',
        title: 'Hành động',
        key: 'action',
        render: object => {
            return (
                <div>
                    <Button
                        size="small"
                        type="link"
                        style={{
                            marginRight: 5,
                            color: 'black',
                            backgroundColor: '#b3e6ff',
                        }}
                        onClick={object.onDetail}
                    >
                        Chi tiết
                    </Button>
                    <Button
                        size="small"
                        type="link"
                        style={{
                            marginRight: 5,
                            color: 'black',
                            backgroundColor: '#b3e6ff',
                        }}
                        onClick={object.onResetPassword}
                    >
                        Đặt lại mật khẩu
                    </Button>
                    <Button
                        size="small"
                        type="link"
                        style={{
                            marginRight: 5,
                            color: 'black',
                            backgroundColor: '#ffccb3',
                        }}
                        onClick={object.onBan}
                    >
                        Cấm
                    </Button>
                    <Button
                        size="small"
                        type="link"
                        style={{
                            marginRight: 5,
                            color: 'black',
                            backgroundColor: '#ff9999',
                        }}
                        onClick={object.onDelete}
                    >
                        Xoá
                    </Button>
                </div>
            )
        },
    },
]

class ListUsers extends Component {
    _onShowDetail = user => {
        this.props.updateCurrentUser(user)
        this.props.showDetailModal()
        this.props.addNewUserState(false)
    }

    _onBan = user => {
        this.props.updateCurrentUser(user)
        this.props.showBanConfirmModal()
    }

    _onDelete = user => {
        this.props.updateCurrentUser(user)
        this.props.showDeleteConfirmModal()
    }

    _onResetPassword = user => {
        this.props.updateCurrentUser(user)
        this.props.showResetPasswordModal()
    }

    render() {
        let { users } = this.props

        // add event
        let complete_users = []
        users.forEach(user => {
            let complete_user = {
                ...user,
                ...{
                    onDetail: () => this._onShowDetail(user),
                    onBan: () => this._onBan(user),
                    onDelete: () => this._onDelete(user),
                    onResetPassword: () => this._onResetPassword(user),
                },
            }
            complete_users.push(complete_user)
        })

        return (
            <div className="ListUsers">
                <Table
                    columns={columns}
                    dataSource={complete_users}
                    bordered
                    pagination={false}
                />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        users: state.user.users,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        showDetailModal: () => {
            dispatch(userActions.action.showModalCurrentUserInfo())
        },
        showDeleteConfirmModal: () => {
            dispatch(userActions.action.showModalConfirmDelteUser())
        },
        showBanConfirmModal: () => {
            dispatch(userActions.action.showModalConfirmBanUser())
        },
        showResetPasswordModal: () => {
            dispatch(userActions.action.showModalResetPassword())
        },
        getCurrentUser: uid => {
            dispatch(userActions.action.getCurrentUser(uid))
        },
        updateCurrentUser: user => {
            dispatch(userActions.action.updateCurrentUser(user))
        },
        addNewUserState: bool => {
            dispatch(userActions.action.addNewUserState(bool))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ListUsers)
